import axios from 'axios';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useAppSelector } from '../../hooks';
import { appSelectors } from '../../redux/appSlice';
import Cookies from 'js-cookie';

enum UsageEnum {
  Press = 'Press',
  Print = 'Print',
  Web = 'Web',
  TV = 'TV',
  Other = 'Other',
}

interface FormValues {
  email: string;
  usage_medium: UsageEnum;
  consent: boolean;
}

interface UsageConsentFormProps {
  onSuccess?: () => void;
}

export const UsageConsentForm = ({ onSuccess }: UsageConsentFormProps) => {
  const { register, formState, handleSubmit } = useForm<FormValues>();
  const csrfToken = useAppSelector(appSelectors.csrfToken);

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    const formResponse = await axios.post(
      `${import.meta.env.VITE_WEBFORM_URL}/submit`,
      {
        webform_id: 'image_library_usage',
        ...data,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': csrfToken,
        },
      }
    );
    if (formResponse.status === 200) {
      Cookies.set('image_library_usage_consent', '1', { expires: 100 });
      onSuccess && onSuccess();
    }
  };

  return (
    <div className="download-usage-wrapper">
      <h3>Usage</h3>
      <p>Please provide us with your email below.</p>
      <p>
        By downloading and using images from this library, you agree to the
        terms of usage as set out in the 'Age positive images' guide on Ageing
        Better's website
      </p>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input-wrapper">
          <label>Email address:</label>
          <input
            {...register('email', {
              required: 'Email address is required',
              pattern: {
                value:
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: 'Please enter a valid email',
              },
            })}
            type="email"
            required
          />
        </div>
        <div>
          <select
            {...register('usage_medium', {
              required: 'Please let us know how you plan to use the images',
            })}
          >
            <option value="Press">Press</option>
            <option value="Print">Print</option>
            <option value="Web">Web</option>
            <option value="TV">TV</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="input-wrapper-checkbox">
          <input {...register('consent')} type="checkbox" id="consent_check" />
          <label htmlFor="consent_check">
            I am happy for you to contact me about the image library.
          </label>
        </div>
        <div>
          If you would like an account so that you can create your own
          collections and you aren't required to input your details whenever
          downloading an image please apply{' '}
          <a href="/image-library?account=register">here</a>
        </div>
        <div>
          <button>Submit</button>
        </div>

        {formState.errors.email?.message && (
          <p className="form-errors">{formState.errors.email?.message}</p>
        )}
        {formState.errors.usage_medium?.message && (
          <p className="form-errors">{formState.errors.email?.message}</p>
        )}
      </form>
    </div>
  );
};
